import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { posSystemTypes } from 'appConstants';

const PosSystemField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const posSystemName = posSystemTypes.find(
		(el) => el.posSystemID === restaurantForFullInfo?.posSystemId,
	)?.posSystemName;

	return <FullInfoField label="posLabel" value={posSystemName} />;
};

export default PosSystemField;
